<script>
import { mapGetters, mapState } from 'vuex';
import AICreditsBox from '@app/components/AICreditsBox.vue';

export default {
  components: {
    AICreditsBox,
  },
  data: () => ({
    isLoading: false,
    hasAICreditsBoxOpen: false,
  }),
  computed: {
    ...mapGetters('auth', {
      authUser: 'user',
      authStore: 'store',
      aiCreditsLeft: 'aiCreditsLeft',
      hasExpertPlan: 'hasExpertPlan',
    }),
    ...mapState('aiContents', [
      'contents',
    ]),
    greeting() {
      const firstname = this.authUser && String(this.authUser.firstname || '').trim();
      return firstname && firstname.toLowerCase() !== 'undefined'
        ? `Bonjour ${firstname} !`
        : 'Bonjour !';
    },
  },
  methods: {
    onBuyCreditsClick() {
      if (this.hasExpertPlan) {
        this.hasAICreditsBoxOpen = true;
        return;
      }

      this.$buefy.dialog.confirm({
        type: 'is-primary',
        hasIcon: true,
        icon: 'gem',
        title: 'Passez EXPERT et utilisez vos assistants IA',
        message: `
          <div class="content">
            <p>
              Recevez <strong>200 crédits IA renouvelés chaque mois</strong> dans le forfait EXPERT,
              et accédez à toutes les fonctionnalités premium de Teachizy pour développer
              un catalogue de formations cohérent, riche et performant.
            </p>
          </div>
        `,
        confirmText: 'Passer EXPERT',
        cancelText: 'Acheter des crédits',
        focusOn: 'cancel',
        onConfirm: () => {
          this.$router.push({ name: 'plan', query: { onglet: 'vous' } });
        },
        onCancel: () => {
          this.hasAICreditsBoxOpen = true;
        },
      });
    },
  },
  created() {
    if (this.$route.query.payment === 'cancel') {
      this.$buefy.dialog.confirm({
        title: 'Avez-vous rencontré un souci ?',
        message: `
          Il semblerait que vous ne soyez pas
          allé au bout de votre achat. Que s'est-il passé ?
        `,
        focusOn: 'cancel',
        onConfirm: () => {
          this.$buefy.loading.open();
          window.location.href = 'https://forms.gle/r4NDEphrspt8Jg8c7';
        },
        cancelText: 'Non merci, rien à dire',
        confirmText: 'Je vous dis tout',
      });
    }

    if (this.$route.query.payment === 'success') {
      this.$buefy.dialog.alert({
        title: 'Votre achat a été effectué avec succès !',
        message: `
          Si vos crédits n'ont pas été mis à jour,
          veuillez attendre 2 minutes et recharger la page.
        `,
      });
    }

    this.isLoading = true;
    this.$store.dispatch('aiContents/fetch', {
      storeUUID: this.authStore.uuid,
    })
      .finally(() => (this.isLoading = false));
  },
};
</script>

<template>
  <div class="container">
    <header class="columns is-vcentered">
      <div class="column is-8">
        <h1 class="title is-4 is-size-5-mobile">
          {{ greeting }}
        </h1>

        <p class="subtitle is-7">
          Voici vos assistants IA pour créer et diffuser plus vite,
          plus simplement et avec plus d’impact vos formations en ligne !
          Retrouvez les assistants d’aide à la création (structure, contenus)
          directement dans le menu de création de vos formations.
        </p>
      </div>
      <div v-if="!$store.getters['auth/hasEnterpriseCapabilities']" class="column is-4">
        <div class="box has-background-gradient-dark-green has-text-white">
          <h2 class="title is-size-7">
            Crédits restants
          </h2>
          <p class="subtitle is-size-3 has-text-black">
            {{ aiCreditsLeft }}
          </p>
          <p class="mt-2">
            <b-button
              class="py-6"
              type="is-black"
              inverted
              expanded
              @click="onBuyCreditsClick"
            >
              Acheter des crédits
            </b-button>
          </p>
        </div>
      </div>
    </header>

    <div class="tabs mb-10 mb-5-mobile is-size-7-mobile">
      <ul>
        <router-link
          tag="li"
          :class="{'is-active': $route.name == 'ai_assistant'}"
          :to="{name: 'ai_assistant', params: $route.params}"
        >
          <a class="has-text-black">Général</a>
        </router-link>
        <router-link
          tag="li"
          :class="{'is-active': $route.name == 'ai_assistant_copywriter'}"
          :to="{name: 'ai_assistant_copywriter', params: $route.params}"
        >
          <a class="has-text-black">Copywriter IA</a>
        </router-link>
        <router-link
          tag="li"
          :to="{name: 'ai_assistant_history', params: $route.params}"
          exact-active-class="is-active"
        >
          <a class="has-text-black">
            <span class="is-hidden-mobile">Historique du Copywriter</span>
            <span class="is-hidden-tablet">Historique</span>
          </a>
        </router-link>
      </ul>
    </div>
    <div>
      <b-skeleton v-if="isLoading" height="400" />
      <router-view v-else />
    </div>

    <b-modal
      v-if="hasAICreditsBoxOpen"
      :can-cancel="false"
      fullScreen
      active
    >
      <AICreditsBox @close="hasAICreditsBoxOpen = false" />
    </b-modal>
  </div>
</template>
